import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FunctionsService } from 'src/app/services/functions.service';
import { Validators, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from 'src/app/app.constants';
import * as XLSX from 'xlsx';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';

@Component({
  selector: 'app-export-alert-log',
  templateUrl: './export-alert-log.component.html',
  styleUrls: ['./export-alert-log.component.css'],
  providers: [ NgxSpinnerService]
})

export class ExportAlertLogComponent implements OnInit {
  @Input() alertId: number;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    public functionsService: FunctionsService,
    private apiService: ApiService,
    private dateAdapter: DateAdapter<Date>,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private angularFireStore: AngularFirestore,
    private modalService: NgbModal) {}

  language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
  minDate: Date;
  maxDate: Date;
  hourRange: any;
  chatMessages: Array<any> = [];

  location: boolean = true;
  formSubmitted: boolean = false;
  exportLogForm = this.formBuilder.group({
    date: new UntypedFormControl('', Validators.compose([Validators.required])),
    hours: new UntypedFormControl('', Validators.compose([Validators.required]))
  });

  ngOnInit() {
    this.dateAdapter.setLocale(this.language); 
    this.hourRange = AppConstants.hourRange;
    this.maxDate = new Date(); 
    this.getAlertDate();
  }
  
  exportData() {
    if (!this.exportLogForm.valid) {
      this.formSubmitted = true;
      return;
    } 
    this.spinner.show();
    this.exportLogForm.value["timeZone"] = (-1)*(new Date().getTimezoneOffset()/60);
    this.exportLogForm.value["alertId"] = this.alertId;
    this.exportLogForm.value["location"] = this.location;
    if(!this.exportLogForm.value['hours']){
      this.exportLogForm.value['hours'] = "00:00:00-23:59:59";
    }
    var hoursSelected = this.exportLogForm.value['hours'].split('-');
    var d = this.exportLogForm.value['date'].toString().split(' ');
    var startDate = new Date(`${d[3]}-${d[2]}-${d[1]}T${hoursSelected[0]}`);
    var endDate = new Date(`${d[3]}-${d[2]}-${d[1]}T${hoursSelected[1]}`);
    this.apiService.alertLogExport(this.exportLogForm.value).subscribe(
      data => {
        var dataArray = [];
        var logs = [];
          let jsonString = JSON.stringify(data);
          let jsonObject = JSON.parse(jsonString);
          var i = 0;
          var k = 0;
          while((i<jsonObject["alertLog"].length)){
            if(jsonObject["alertLog"][i]){
              var newDate = new Date(jsonObject["alertLog"][i].eventDate+"Z");
              if(newDate.getTime()){
                  logs[k] = [];
                if(jsonObject["alertLog"][i].name == null){
                  var params = (jsonObject["alertLog"][i].description.split(","));
                  logs[k][1] = this.translate.instant("alert_activity_export.modified_alert_type", {name: params[0], pastAlertType: params[1], newAlertType: params[2]});
                }
                else if(jsonObject["alertLog"][i].name == "attend_timer" || jsonObject["alertLog"][i].name == "close_timer"){
                  var params = (jsonObject["alertLog"][i].description.split("."))
                  logs[k][1] = this.translate.instant("alert_activity_export." + jsonObject["alertLog"][i].name, {days: params[0], time: params[1]});
                }
                else if(jsonObject["alertLog"][i].name == "video_available"){
                  var params = (jsonObject["alertLog"][i].description.split(","));
                  logs[k][1] = this.translate.instant("alert_activity_export.video_available", {value: params[1] + "s"});
                }
                else{
                  logs[k][1] = this.translate.instant(`alert_activity_export.${jsonObject["alertLog"][i].name}`, {value: jsonObject["alertLog"][i].description == "" ? "" : this.translate.instant(jsonObject["alertLog"][i].description)});
                }
                  logs[k][0] = this.functionsService.convertUTCDateToLocalDate(jsonObject["alertLog"][i].eventDate);
                    if(this.language == "es"){
                      dataArray.push({"Fecha":logs[k][0],"Descripcion":logs[k][1]});
                    }else{
                      dataArray.push({"Date":logs[k][0],"Description":logs[k][1]});
                    }
                i++;
              }
              k++;
            }
            else if(jsonObject["alertLog"][i]){
              logs[k] = [];
              if(jsonObject["alertLog"][i]['name'] == null){
                var params = (jsonObject["alertLog"][i].description.split(","));
                  logs[k][1] = this.translate.instant("alert_activity_export.modified_alert_type", {name: params[0], pastAlertType: params[1], newAlertType: params[2]});
              }
              else if(jsonObject["alertLog"][i].name == "video_available"){
                var params = (jsonObject["alertLog"][i].description.split(","));
                logs[k][1] = this.translate.instant("alert_activity_export.video_available", {value: params[1] + "s"});
              }
              else{
                logs[k][1] = this.translate.instant(`alert_activity_export.${jsonObject["alertLog"][i].name}`, {value: jsonObject["alertLog"][i].description == "" ? "" : this.translate.instant(jsonObject["alertLog"][i].description)});
              }
                logs[k][0] = this.functionsService.convertUTCDateToLocalDate(jsonObject["alertLog"][i].eventDate);
                  if(this.language == "es"){
                    dataArray.push({"Fecha":logs[k][0],"Descripcion":logs[k][1]});
                  }else{
                    dataArray.push({"Date":logs[k][0],"Description":logs[k][1]});
                  }
              i++;
              k++;
            }
          }
          if(dataArray.length > 0){ 
            const fileName = `SA-${this.alertId}.csv`;
            const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataArray);
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'SA');
            XLSX.writeFile(wb, fileName);
          }
          else{
              const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
              modalRef.componentInstance.title = "Error";
              modalRef.componentInstance.message = this.translate.instant('general.no_data_avail_date');
          }
          this.spinner.hide();
          this.activeModal.close();
        });
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      };
  }

  getAlertDate(){
    this.spinner.show();
    this.apiService.alertStartDate(this.alertId).subscribe(
        data => {
            this.minDate = new Date(data["createdDate"].toString());
            this.maxDate = new Date(data["closedDate"].toString());
            this.spinner.hide();
        },
        error => {
            this.minDate = new Date();
            this.maxDate = new Date();
            this.spinner.hide();
        }
    );
  }

  get date() { return this.controlGetter('date'); }
  get hours() { return this.controlGetter('hours'); }

  controlGetter(controlName) {
    const control =  this.exportLogForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }

  selectLocations(locationSetting: boolean){
      this.location = locationSetting;
      if(!this.location){
        this.exportLogForm.setControl('hours', new UntypedFormControl(''))
      }
      else{
        this.exportLogForm.setControl('hours', new UntypedFormControl('', Validators.compose([Validators.required])));
      }
  }
}